// LOCAL STORAGE CONSTANTS

export const KEY_APP_STATE = 'appState';
export const KEY_TOKENS = 'sgp_tokens';
